import apiV2 from '../api/v2';
import { toDmError } from './dmErrors';

export interface DmQuickstart {
    id: string;
    name: string;
    description: string | null;
}

export async function listQuickstarts(patientId: string): Promise<DmQuickstart[]> {
    try {
        const response = await apiV2.get<{ success: boolean; data: DmQuickstart[] }>(
            `/patients/${patientId}/dm/monitoring/quickstarts`
        );
        return response.data.data;
    } catch (err) {
        throw toDmError(err);
    }
}
